import Regularization from "../../../../content/blog/regularization-interactive/Regularization.js";
import "katex/dist/katex.min.css";
import * as React from 'react';
export default {
  Regularization,
  React
};